import { motion } from "framer-motion";
import { scrollToId } from "@/components/Header";
import { useLang } from "@/lib/site-lang";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#050505] border-t border-white/10 pt-24 lg:pt-32 overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 pb-20">
          <div>
            <p className="mono-label text-[#52525B] mb-4">{t.footer.findUs}</p>
            <p className="text-[#A1A1AA] text-sm leading-relaxed">
              <a href="https://www.google.com/maps/search/?api=1&query=4273+Laurentian+Autoroute" target="_blank" rel="noopener noreferrer" data-testid="footer-address" className="hover:text-[#E67E22] transition-colors duration-300">4273 Laurentian Autoroute ↗</a><br />
              <a href="tel:+15142666607" data-testid="footer-phone" className="hover:text-[#E67E22] transition-colors duration-300">514 266 6607</a><br />
              <a href="mailto:Pierre.localmoto@gmail.com" data-testid="footer-email" className="hover:text-[#E67E22] transition-colors duration-300">Pierre.localmoto@gmail.com ↗</a>
            </p>
          </div>
          <div>
            <p className="mono-label text-[#52525B] mb-4">{t.footer.jumpTo}</p>
            <div className="flex flex-col gap-2">
              {t.footer.links.map((l) => (
                <button
                  key={l.href}
                  data-testid={`footer-link-${l.href.replace("#", "")}`}
                  onClick={() => scrollToId(l.href)}
                  className="text-left text-[#A1A1AA] text-sm hover:text-[#E67E22] transition-colors duration-300 w-fit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D35400]"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="footer-link-admin"
                onClick={() => (window.location.href = "/admin")}
                className="text-left text-[#52525B] text-sm hover:text-[#E67E22] transition-colors duration-300 w-fit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D35400]"
              >
                {t.footer.staffLogin}
              </button>
            </div>
          </div>
        </div>
      </div>

      <motion.div
        initial={{ y: 120, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="px-6 lg:px-12"
      >
        <img src="/logo.png" alt="Local Moto" className="w-full max-w-4xl mx-auto select-none" data-testid="footer-wordmark" />
      </motion.div>

      <div className="border-t border-white/10 mt-[-1vw] relative bg-[#050505]">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between gap-3">
          <p className="mono-label text-[#52525B]">{t.footer.rights}</p>
          <p className="mono-label text-[#52525B]">{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
